export const USDC_PRECISION = 6
export const DEFAULT_SLIPPAGE = '0.002' // .2%
